import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { SelectItem } from "primeng/api";
import { TranslateService } from "@ngx-translate/core";
import { MICustomFunctionsParams } from "../../../models/fields/custom-function-params";

@Injectable({
    providedIn: 'root'
})
export class ListsForFieldsFunctions {
    text: any;
    selectItemsText: any;
    constructor(
        private translateService: TranslateService,
    ) {
        this.initText();
    }
    initText() {
        this.translateService.stream('unionRequest.selectItems').subscribe(translation => {
            this.selectItemsText = translation;
        });
    }


    getYearsAgoList(customFunctionsObj: MICustomFunctionsParams, yearsAgo: number): Observable<Array<SelectItem>> {

        const options: SelectItem[] = new Array<SelectItem>();
        const currentYear = new Date().getFullYear();
        const startYear = currentYear - yearsAgo;

        for (let year = currentYear; year >= startYear; year--) {
            options.push({ value: year.toString(), label: year.toString() });
        }
        options.unshift({ value: null, label: this.selectItemsText.default });
        return of(options);

    }

}